"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var react_uid_1 = require("react-uid");
var Tip_1 = __importDefault(require("@seaweb/coral/components/Tip/Tip"));
var useControlProp_1 = __importDefault(require("@seaweb/coral/hooks/useControlProp"));
var useCompoundBlur_1 = __importDefault(require("@seaweb/coral/hooks/useCompoundBlur"));
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var useForkRef_1 = __importDefault(require("@seaweb/coral/hooks/useForkRef"));
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
var forwardAs_1 = __importDefault(require("@seaweb/coral/hoc/forwardAs"));
var getRoot_1 = __importStar(require("@seaweb/coral/utils/getRoot"));
var useRovingIndex_1 = __importDefault(require("@seaweb/coral/hooks/useRovingIndex"));
var childrenWithIndex_1 = __importDefault(require("@seaweb/coral/utils/childrenWithIndex"));
var MenuContext_1 = __importDefault(require("./MenuContext"));
var internals_1 = require("./internals");
var WrappedTip = forwardAs_1.default(Tip_1.default);
var StyledTip = styled_1.default(WrappedTip)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n\n  ", "\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  display: block;\n\n  ",
    "\n\n  &:focus {\n    outline: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", "px 0;\n  "], ["\n    padding: ", "px 0;\n  "])), theme.spacing.factor);
});
var OFFSET = [0, 1];
var Menu = react_1.forwardRef(function Menu(_a, ref) {
    var as = _a.as, _b = _a.role, role = _b === void 0 ? 'menu' : _b, idProp = _a.id, _c = _a.tabIndex, tabIndex = _c === void 0 ? -1 : _c, button = _a.button, children = _a.children, _d = _a.arrow, arrow = _d === void 0 ? null : _d, activeProp = _a.active, _e = _a.initialActive, initialActive = _e === void 0 ? false : _e, onActiveChange = _a.onActiveChange, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown, _f = _a.springConfig, springConfig = _f === void 0 ? internals_1.SPRING_CONFIG : _f, _g = _a.offset, offset = _g === void 0 ? OFFSET : _g, _h = _a.container, container = _h === void 0 ? (getRoot_1.warnSSR('Menu', 'container'), getRoot_1.default()) : _h, props = __rest(_a, ["as", "role", "id", "tabIndex", "button", "children", "arrow", "active", "initialActive", "onActiveChange", "onBlur", "onKeyDown", "springConfig", "offset", "container"]);
    var id = fallback_1.default(idProp, react_uid_1.useUID());
    var popupId = "menu:" + id + "-popup";
    var _j = __read(useControlProp_1.default(activeProp, initialActive, onActiveChange), 2), active = _j[0], setActive = _j[1];
    var _k = useCompoundBlur_1.default(function () { return setActive(false); }), handleCompoundBlur = _k.handleCompoundBlur, register = _k.register;
    var _l = useRovingIndex_1.default(), getItem = _l.getItem, getRelativeTarget = _l.getRelativeTarget, setItemRef = _l.setItemRef;
    var buttonOriginalRef = button.ref;
    var buttonRef = react_1.useRef(null);
    var buttonProps = {
        ref: useForkRef_1.default(buttonOriginalRef, useForkRef_1.default(buttonRef, function (dom) { return register('button', dom); })),
        onBlur: useWrapEvent_1.default(button.props.onBlur, handleCompoundBlur),
        onClick: useWrapEvent_1.default(button.props.onClick, function () { return setActive(!active); }),
        onKeyDown: useWrapEvent_1.default(button.props.onKeyDown, function (e) {
            if (e.key === 'Escape') {
                setActive(false);
            }
            else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                setActive(true);
                e.preventDefault();
                var key_1 = e.key;
                requestAnimationFrame(function () {
                    var _a = __read(getItem(key_1 === 'ArrowDown' ? 0 : -1), 1), target = _a[0];
                    if (target)
                        target.focus();
                });
            }
        }),
        'aria-haspopup': true,
        'aria-expanded': active,
        'aria-controls': popupId,
    };
    if (active)
        buttonProps['data-coral-pressed'] = '';
    var popupRef = react_1.useRef(null);
    var handleRef = useForkRef_1.default(useForkRef_1.default(ref, function (el) { return register('popup', el); }), popupRef);
    var handleBlur = useWrapEvent_1.default(onBlur, handleCompoundBlur);
    var handleKeyDown = useWrapEvent_1.default(onKeyDown, function (e) {
        if (popupRef.current.contains(e.target)) {
            if (e.key === 'Escape') {
                setActive(false);
                if (buttonRef.current) {
                    buttonRef.current.focus();
                }
            }
            else if (e.key === 'Tab' && buttonRef.current) {
                buttonRef.current.focus();
            }
        }
        if (popupRef.current === e.target) {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                var _a = __read(getItem(e.key === 'ArrowDown' ? 0 : -1), 1), target = _a[0];
                if (target)
                    target.focus();
            }
        }
    });
    var ctx = {
        getRelativeTarget: getRelativeTarget,
        setItemRef: setItemRef,
        buttonRef: buttonRef,
        rootButtonRef: buttonRef,
        popupRef: popupRef,
        active: active,
        setActive: setActive,
        setRootActive: setActive,
        register: register,
    };
    return (react_1.default.createElement(MenuContext_1.default.Provider, { value: ctx },
        react_1.default.createElement(StyledTip, __assign({ ref: handleRef, id: popupId, role: role, tabIndex: tabIndex, active: active, arrow: arrow, springConfig: springConfig, offset: offset, onBlur: handleBlur, onKeyDown: handleKeyDown, content: childrenWithIndex_1.default(children), container: container }, props), react_1.cloneElement(button, buttonProps))));
});
exports.default = Menu;
var templateObject_1, templateObject_2;
